// react
import React, { Suspense } from "react";

// components
import Spinner from "../../components/Spinner/ComponentLoader";

// load in the goal tree
const Dashboard = React.lazy(() => import("./Dashboard"));

const DashboardLazyLoader = () => (
	<Suspense fallback={<Spinner />}>
		<Dashboard />
	</Suspense>
);

export default DashboardLazyLoader;
